import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-brand-choco" data-id="element-89" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-90" data-mp="9tbcosa2cgg6">
        <p className="font-script text-[0.9rem] font-bold italic text-brand-pinkdark" data-id="element-91" data-mp="et67v80vfs71">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-xl border-2 border-brand-gold bg-brand-cream p-3 text-left" data-id="element-92" data-mp="jrr7b58au7uf">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border-2 border-brand-gold bg-brand-choco" data-id="element-93" data-mp="ns1c4ekcus7p">
            <ShieldCheckIcon size={20} className="text-brand-gold" data-id="element-94" data-mp="xkgrd449p2ow" />
          </span>
          <div data-id="element-95" data-mp="12ja7z5eup9ta">
            <h2 id="garantia" className="font-display text-sm font-extrabold uppercase leading-tight sm:text-base" data-id="element-96" data-mp="12jjx6qs2ncxx">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-[0.78rem] leading-snug text-brand-choco/80" data-id="element-97" data-mp="25syiyof03af4">
              Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si
              considerás que el sistema no es adecuado para vos, podés solicitar
              un reembolso dentro del período establecido según los términos de
              devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}